// TODO UPDATE AT ATS FLIP: change to 'asOfSept'
// TODO UPDATE AT TERM 2 FLIP: 'change to 'asOfJan'
export const CurrentGraduationThresholdAsOfMonth = 'asOfJan';
